export default "__VITE_ASSET__Cig$FJvM__"